/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @author Jiri Moc <jiri.moc@outlook.cz>
 * @license See LICENSE file distributed with this source code.
 */

import { Form } from "../shared/FormModel/FormModel";
import { SectionGroup } from "../shared/FormModel/elements/FormSectionGroup";
import { Section } from "../shared/FormModel/elements/FormSection";
import { Row } from "../shared/FormModel/elements/FormRow";
import { FieldText, FormFieldText } from "../shared/FormModel/elements/FormFieldText";
import { FieldSelect } from "../shared/FormModel/elements/FormFieldSelect";
import { FieldLabel } from "../shared/FormModel/elements/FormFieldLabel";
import { RowList, FormRowList } from "../shared/FormModel/elements/FormRowList";
import { HTMLContent } from "../shared/FormModel/elements/FormHTMLContent";
import { parseNumber, formatNumber, printNumberFormatter } from "../shared/formatting";
import { HiddenExpression, FormHiddenExpression } from "../shared/FormModel/elements/FormHiddenExpression";

export const form_cenovaNabidkaKuchynSestava = Form({
	id: "cenova-nabidka-kuchyn-sestava",
	version: "2020-07-r1",
	title: "Cenová nabídka - kuchyň",
	icon: "table-plus",
	showInMenu: true
}, [
	SectionGroup({}, [
		Section({
			id: "detail-zakaznika",
			title: "Detail zákazníka"
		}, [
			Row({}, [
				FieldText({
					width: "1/2",
					id: "zakaznik-jmeno",
					label: "Jméno a příjmení",
					placeholder: "Jan Novák"
				}),
				FieldText({
					width: "1/2",
					id: "zakaznik-adresa",
					label: "Adresa",
					placeholder: "Třešňová 23, Mladé 380 01"
				})
			]),
			Row({}, [
				FieldText({
					width: "1/2",
					id: "zakaznik-kontakt",
					label: "Kontakt",
					placeholder: "jan.novak@email.cz, + 420 123 456 789"
				}),
				FieldText({
					width: "1/2",
					id: "datum-vytvoreno",
					label: "Vytvořeno dne",
					placeholder: "1.1. 2020"
				})
			])
		]),
	]),
	SectionGroup({}, [
		Section({
			id: "provedeni-sestavy-nabytku",
			title: "Provedení sestavy nábytku"
		}, [
			// první řádek - dveře , korpus
			Row({}, [
				FieldText({
					width: "1/2",
					id: "dvere",
					label: "Dveře",
					placeholder: "---"
				}),
				FieldText({
					width: "1/2",
					id: "korpus",
					label: "Korpus",
					placeholder: "---"
				})
			]),
			// druhý řádek - pracovní deska, obklad zástěna
			Row({}, [
				FieldText({
					width: "1/2",
					id: "provedeni-pracovni-deska",
					label: "Pracovní deska",
					placeholder: "---"
				}),
				FieldText({
					width: "1/2",
					id: "provedeni-obklad-zastena",
					label: "Obklad, zástěna",
					placeholder: "---"
				}),
			]),
			// třetí řádek - sokl, těsnění, úchytky
			Row({}, [
				FieldText({
					width: "1/3",
					id: "provedeni-sokl",
					label: "Sokl",
					placeholder: "---"
				}),
				FieldText({
					width: "1/3",
					id: "provedeni-tesneni",
					label: "Těsnění",
					placeholder: "---"
				}),
				FieldText({
					width: "1/3",
					id: "provedeni-uchytky",
					label: "Úchytky",
					placeholder: "---"
				}),
			]),
			// čtvrtý řádek - rámeček a sklo
			Row({}, [
				FieldText({
					width: "1/2",
					id: "provedeni-ramecek",
					label: "Rámeček",
					placeholder: "---"
				}),
				FieldText({
					width: "1/2",
					id: "provedeni-sklo",
					label: "Sklo",
					placeholder: "---"
				})
			]),
			// pátý řádek - další specifikace
			Row({}, [
				FieldText({
					width: "1",
					id: "dalsi-specifikace",
					label: "Další specifikace",
					placeholder: "---",
					rows: 4
				})
			])
		]),
	]),
	SectionGroup({}, [
		Section({
			id: "hlavni-rozmery",
			title: "Rozměry sestavy"
		}, [
			Row({}, [
				FieldText({
					width: "1/4",
					id: "vyska-spodni-skrinky",
					label: "Výška spodních skříněk",
					placeholder: "---"
				}),
				FieldText({
					width: "1/4",
					id: "vyska-vysoke-skrinky",
					label: "Výška vysokých skříněk",
					placeholder: "---"
				}),
				FieldText({
					width: "1/4",
					id: "vyska-horni-skrinky",
					label: "Výška horních skříněk",
					placeholder: "---"
				}),
				FieldText({
					width: "1/4",
					id: "vyska-pracovni-deska",
					label: "Výška pracovní desky",
					placeholder: "---"
				})
			])
		]),
	]),
	SectionGroup({}, [
		Section({
			id: "kovani",
			title: "Kování"
		}, [
			Row({}, [
				FieldText({
					width: "1/3",
					id: "kovani-zavesy",
					label: "Závěsy",
					placeholder: "---"
				}),
				FieldText({
					width: "1/3",
					id: "kovani-vysuvy",
					label: "Výsuvy",
					placeholder: "---"
				}),
				FieldText({
					width: "1/3",
					id: "kovani-vyklopy",
					label: "Výklopy",
					placeholder: "---"
				})
			]),
			Row({}, [
				FieldText({
					width: "1/3",
					id: "kovani-vysoka-skrinka",
					label: "Vysoká skříňka",
					placeholder: "---"
				}),
				FieldText({
					width: "1/3",
					id: "kovani-spodni-skrinka",
					label: "Spodní skříňka",
					placeholder: "---"
				}),
				FieldText({
					width: "1/3",
					id: "kovani-rohova-skrinka",
					label: "Rohová skříňka",
					placeholder: "---"
				})
			])
		]),
	]),
	SectionGroup({
		spaceBefore: true
	}, [
		Section({
			id: "list-skrinek",
			title: "Položky kuchyně"
		}, [
			RowList({}, [
				FieldText({
					id: "nazev",
					label: "Popisek / kód",
					placeholder: "---"
				}),
				FieldSelect({
					width: "1/8",
					id: "sazba-dph",
					label: "Sazba DPH",
					options: [{
						value: "21",
						label: "21%"
					}, {
						value: "15",
						label: "15%"
					}]
				}),
				FieldText({
					width: "1/6",
					id: "cena",
					tag: "skrinka-cena",
					label: "Cena vč. DPH",
					placeholder: "---",
					pattern: /^[0-9 ]+((,|\.)[0-9]+)?$/,
					align: "right",
					labelAlign: "right",
					suffix: "Kč",
					printFormatter: printNumberFormatter(2)
				})
			]),
			Row({
				colorSchema: "heading"
			}, [
				FieldLabel({
					label: "Celková cena za kuchyni vč. DPH",
					style: "summary"
				}),
				HiddenExpression({
					tag: "skrinky-celkem",
					value: (model) => {
						let total = 0;
						const list = model.getElementByTag<FormFieldText>("skrinka-cena");

						for (let i = 0; i < list.length; i++) {
							total += parseNumber(list[i].getState().value, 0);
						}

						return total;
					}
				}),
				FieldLabel({
					width: "1/6",
					value: (model) => {
						const total = model.getElementByTag<FormHiddenExpression>("skrinky-celkem")[0].getState().value;
						return formatNumber(total, 2);
					},
					suffix: "Kč",
					align: "right",
					style: "summary"
				})
			]),
			Row({
				print: false
			}, [
				FieldText({
					id: "nazev-slevy",
					tag: "skrinky-sleva-nazev",
					label: "Název slevy",
					value: "Sleva na kuchyňskou sestavu"
				}),
				FieldText({
					width: "1/6",
					id: "sleva",
					tag: "skrinky-sleva",
					label: "Sleva",
					pattern: /^[0-9 ]+((,|\.)[0-9]+)?$/,
					align: "right",
					labelAlign: "right",
					suffix: "%",
					value: "0"
				}),
				FieldLabel({
					width: "1/6",
					label: "Výše slevy",
					value: (model) => {
						const total = model.getElementByTag<FormHiddenExpression>("skrinky-celkem")[0].getState().value;
						const discount = parseNumber(model.getElementByTag<FormHiddenExpression>("skrinky-sleva")[0].getState().value);

						const discountAmount = -(total * (discount / 100));

						return formatNumber(discountAmount, 2);
					},
					align: "right",
					labelAlign: "right",
					suffix: "Kč"
				}),
				HiddenExpression({
					tag: "skrinky-celkem-po-sleve",
					value: (model) => {
						const total = model.getElementByTag<FormHiddenExpression>("skrinky-celkem")[0].getState().value;
						const discount = parseNumber(model.getElementByTag<FormHiddenExpression>("skrinky-sleva")[0].getState().value);

						const afterDiscount = total - (total * (discount / 100));

						return afterDiscount;
					}
				}),
			]),
			Row({
				colorSchema: "highlight",
				display: (model) => {
					const discount = parseNumber(model.getElementByTag<FormHiddenExpression>("skrinky-sleva")[0].getState().value, 0);
					return discount > 0;
				}
			}, [
				FieldLabel({
					label: (model) => {
						const discountName = model.getElementByTag<FormFieldText>("skrinky-sleva-nazev")[0].getState().value;
						const discount = parseNumber(model.getElementByTag<FormHiddenExpression>("skrinky-sleva")[0].getState().value);

						return "Cena po slevě vč. DPH (" + (discountName || "") + " " + formatNumber(discount, 0) + "%)";
					},
					style: "summary"
				}),
				FieldLabel({
					width: "1/6",
					align: "right",
					value: (model) => {
						const total = model.getElementByTag<FormHiddenExpression>("skrinky-celkem")[0].getState().value;
						const discount = parseNumber(model.getElementByTag<FormHiddenExpression>("skrinky-sleva")[0].getState().value);

						const afterDiscount = total - (total * (discount / 100));

						return formatNumber(afterDiscount, 2);
					},
					style: "summary",
					suffix: "Kč"
				})
			])
		]),
	]),
	// spotřebiče
	SectionGroup({
		spaceBefore: true
	}, [
		Section({
			id: "list-spotrebice",
			title: "Spotřebiče"
		}, [
			Row({
				colorSchema: "heading"
			}, [
				FieldLabel({
					label: "Popisek (název, kód)",
				}),
				FieldLabel({
					width: "1/10",
					label: "DPH",
					labelAlign: "right"
				}),
				FieldLabel({
					width: "1/6",
					label: "Cena za KS",
					labelAlign: "right"
				}),
				FieldLabel({
					width: "1/10",
					label: "Počet KS",
					labelAlign: "right"
				}),
				FieldLabel({
					width: "1/6",
					label: "Cena celkem vč. DPH",
					labelAlign: "right"
				}),
				FieldLabel({
					width: "row-actions"
				})
			]),
			RowList({}, [
				FieldText({
					id: "popis",
					placeholder: "---",
					verticalAlign: "center"
				}),
				FieldSelect({
					width: "1/10",
					id: "sazba-dph",
					verticalAlign: "center",
					align: "right",
					options: [{
						value: "21",
						label: "21%"
					}, {
						value: "15",
						label: "15%"
					}]
				}),
				FieldText({
					width: "1/6",
					id: "cena-za-ks",
					placeholder: "---",
					pattern: /^[0-9]+((,|\.)[0-9]+)?$/,
					align: "right",
					labelAlign: "right",
					verticalAlign: "center",
					suffix: "Kč"
				}),
				FieldText({
					width: "1/10",
					id: "pocet-ks",
					placeholder: "---",
					pattern: /^[0-9]+((,|\.)[0-9]+)?$/,
					align: "right",
					labelAlign: "right",
					verticalAlign: "center"
				}),
				HiddenExpression({
					tag: "spotrebice-spotrebice-celkem-radek",
					value: (model, currEl) => {
						const elPath = currEl.getPath();
						const rowId = elPath[elPath.length - 1].id; // -1 because this element doesn't have any ID
						const rowContent = currEl.getParent<FormRowList>().getRowContentById(rowId);

						const price = parseNumber((rowContent[2] as FormFieldText).getState().value);
						const pcs = parseNumber((rowContent[3] as FormFieldText).getState().value);

						return price * pcs;
					}
				}),
				FieldLabel({
					width: "1/6",
					id: "cena-celkem",
					tag: "spotrebice-radek-celkem",
					align: "right",
					labelAlign: "right",
					verticalAlign: "center",
					value: (model, currEl) => {
						const elPath = currEl.getPath();
						const rowId = elPath[elPath.length - 2].id;
						const rowContent = currEl.getParent<FormRowList>().getRowContentById(rowId);

						return formatNumber((rowContent[4] as FormHiddenExpression).getState().value, 2) + " Kč";
					}
				})
			]),
			Row({
				colorSchema: "heading"
			}, [
				FieldLabel({
					label: "Celková cena za spotřebiče vč. DPH",
					style: "summary"
				}),
				HiddenExpression({
					tag: "spotrebice-celkem",
					value: (model) => {
						let total = 0;
						const list = model.getElementByTag<FormFieldText>("spotrebice-radek-celkem");

						for (let i = 0; i < list.length; i++) {
							total += parseNumber(list[i].getState().value, 0);
						}

						return total;
					}
				}),
				FieldLabel({
					width: "1/6",
					value: (model) => {
						const total = model.getElementByTag<FormHiddenExpression>("spotrebice-celkem")[0].getState().value;
						return formatNumber(total, 2);
					},
					suffix: "Kč",
					align: "right",
					style: "summary"
				})
			]),
			Row({
				print: false
			}, [
				FieldText({
					id: "nazev-slevy",
					tag: "spotrebice-sleva-nazev",
					label: "Název slevy",
					value: "Sleva na spotřebiče"
				}),
				FieldText({
					width: "1/6",
					id: "sleva",
					tag: "spotrebice-sleva",
					label: "Sleva",
					pattern: /^[0-9 ]+((,|\.)[0-9]+)?$/,
					align: "right",
					labelAlign: "right",
					suffix: "%",
					value: "0"
				}),
				FieldLabel({
					width: "1/6",
					label: "Výše slevy",
					value: (model) => {
						const total = model.getElementByTag<FormHiddenExpression>("spotrebice-celkem")[0].getState().value;
						const discount = parseNumber(model.getElementByTag<FormHiddenExpression>("spotrebice-sleva")[0].getState().value);

						const discountAmount = -(total * (discount / 100));

						return formatNumber(discountAmount, 2);
					},
					align: "right",
					labelAlign: "right",
					suffix: "Kč"
				}),
				HiddenExpression({
					tag: "spotrebice-celkem-po-sleve",
					value: (model) => {
						const total = model.getElementByTag<FormHiddenExpression>("spotrebice-celkem")[0].getState().value;
						const discount = parseNumber(model.getElementByTag<FormHiddenExpression>("spotrebice-sleva")[0].getState().value);

						const afterDiscount = total - (total * (discount / 100));

						return afterDiscount;
					}
				}),
			]),
			Row({
				colorSchema: "highlight",
				display: (model) => {
					const discount = parseNumber(model.getElementByTag<FormHiddenExpression>("spotrebice-sleva")[0].getState().value, 0);
					return discount > 0;
				}
			}, [
				FieldLabel({
					label: (model) => {
						const discountName = model.getElementByTag<FormFieldText>("spotrebice-sleva-nazev")[0].getState().value;
						const discount = parseNumber(model.getElementByTag<FormHiddenExpression>("spotrebice-sleva")[0].getState().value);

						return "Cena spotřebičů po slevě vč. DPH (" + (discountName || "") + " " + formatNumber(discount, 0) + "%)";
					},
					style: "summary"
				}),
				FieldLabel({
					width: "1/6",
					align: "right",
					value: (model) => {
						const total = model.getElementByTag<FormHiddenExpression>("spotrebice-celkem")[0].getState().value;
						const discount = parseNumber(model.getElementByTag<FormHiddenExpression>("spotrebice-sleva")[0].getState().value);

						const afterDiscount = total - (total * (discount / 100));

						return formatNumber(afterDiscount, 2);
					},
					style: "summary",
					suffix: "Kč"
				})
			])
		]),
	]),
	SectionGroup({
		spaceBefore: true
	}, [
		Section({
			id: "list-ruzne",
			title: "Různé"
		}, [
			Row({
				colorSchema: "heading"
			}, [
				FieldLabel({
					label: "Popisek (název, kód)",
				}),
				FieldLabel({
					width: "1/10",
					label: "DPH",
					labelAlign: "right"
				}),
				FieldLabel({
					width: "1/6",
					label: "Cena za KS",
					labelAlign: "right"
				}),
				FieldLabel({
					width: "1/10",
					label: "Počet KS",
					labelAlign: "right"
				}),
				FieldLabel({
					width: "1/6",
					label: "Cena celkem vč. DPH",
					labelAlign: "right"
				}),
				FieldLabel({
					width: "row-actions"
				})
			]),
			RowList({}, [
				FieldText({
					id: "popis",
					placeholder: "---",
					verticalAlign: "center"
				}),
				FieldSelect({
					width: "1/10",
					id: "sazba-dph",
					verticalAlign: "center",
					align: "right",
					options: [{
						value: "21",
						label: "21%"
					}, {
						value: "15",
						label: "15%"
					}]
				}),
				FieldText({
					width: "1/6",
					id: "cena-za-ks",
					placeholder: "---",
					pattern: /^[0-9]+((,|\.)[0-9]+)?$/,
					align: "right",
					labelAlign: "right",
					verticalAlign: "center",
					suffix: "Kč"
				}),
				FieldText({
					width: "1/10",
					id: "pocet-ks",
					placeholder: "---",
					pattern: /^[0-9]+((,|\.)[0-9]+)?$/,
					align: "right",
					labelAlign: "right",
					verticalAlign: "center"
				}),
				HiddenExpression({
					tag: "ruzne-ruzne-celkem-radek",
					value: (model, currEl) => {
						const elPath = currEl.getPath();
						const rowId = elPath[elPath.length - 1].id; // -1 because this element doesn't have any ID
						const rowContent = currEl.getParent<FormRowList>().getRowContentById(rowId);

						const price = parseNumber((rowContent[2] as FormFieldText).getState().value);
						const pcs = parseNumber((rowContent[3] as FormFieldText).getState().value);

						return price * pcs;
					}
				}),
				FieldLabel({
					width: "1/6",
					id: "cena-celkem",
					tag: "ruzne-radek-celkem",
					align: "right",
					labelAlign: "right",
					verticalAlign: "center",
					value: (model, currEl) => {
						const elPath = currEl.getPath();
						const rowId = elPath[elPath.length - 2].id;
						const rowContent = currEl.getParent<FormRowList>().getRowContentById(rowId);

						return formatNumber((rowContent[4] as FormHiddenExpression).getState().value, 2) + " Kč";
					}
				})
			]),
			Row({
				colorSchema: "heading"
			}, [
				FieldLabel({
					label: "Celková cena za různé položky vč. DPH",
					style: "summary"
				}),
				HiddenExpression({
					tag: "ruzne-celkem",
					value: (model) => {
						let total = 0;
						const list = model.getElementByTag<FormFieldText>("ruzne-radek-celkem");

						for (let i = 0; i < list.length; i++) {
							total += parseNumber(list[i].getState().value, 0);
						}

						return total;
					}
				}),
				FieldLabel({
					width: "1/6",
					value: (model) => {
						const total = model.getElementByTag<FormHiddenExpression>("ruzne-celkem")[0].getState().value;
						return formatNumber(total, 2);
					},
					suffix: "Kč",
					align: "right",
					style: "summary"
				})
			]),
			Row({
				print: false
			}, [
				FieldText({
					id: "nazev-slevy",
					tag: "ruzne-sleva-nazev",
					label: "Název slevy",
					value: "Sleva na položky"
				}),
				FieldText({
					width: "1/6",
					id: "sleva",
					tag: "ruzne-sleva",
					label: "Sleva",
					pattern: /^[0-9 ]+((,|\.)[0-9]+)?$/,
					align: "right",
					labelAlign: "right",
					suffix: "%",
					value: "0"
				}),
				FieldLabel({
					width: "1/6",
					label: "Výše slevy",
					value: (model) => {
						const total = model.getElementByTag<FormHiddenExpression>("ruzne-celkem")[0].getState().value;
						const discount = parseNumber(model.getElementByTag<FormHiddenExpression>("ruzne-sleva")[0].getState().value);

						const discountAmount = -(total * (discount / 100));

						return formatNumber(discountAmount, 2);
					},
					align: "right",
					labelAlign: "right",
					suffix: "Kč"
				}),
				HiddenExpression({
					tag: "ruzne-celkem-po-sleve",
					value: (model) => {
						const total = model.getElementByTag<FormHiddenExpression>("ruzne-celkem")[0].getState().value;
						const discount = parseNumber(model.getElementByTag<FormHiddenExpression>("ruzne-sleva")[0].getState().value);

						const afterDiscount = total - (total * (discount / 100));

						return afterDiscount;
					}
				}),
			]),
			Row({
				colorSchema: "highlight",
				display: (model) => {
					const discount = parseNumber(model.getElementByTag<FormHiddenExpression>("ruzne-sleva")[0].getState().value, 0);
					return discount > 0;
				}
			}, [
				FieldLabel({
					label: (model) => {
						const discountName = model.getElementByTag<FormFieldText>("ruzne-sleva-nazev")[0].getState().value;
						const discount = parseNumber(model.getElementByTag<FormHiddenExpression>("ruzne-sleva")[0].getState().value);

						return "Cena položek po slevě vč. DPH (" + (discountName || "") + " " + formatNumber(discount, 0) + "%)";
					},
					style: "summary"
				}),
				FieldLabel({
					width: "1/6",
					align: "right",
					value: (model) => {
						const total = model.getElementByTag<FormHiddenExpression>("ruzne-celkem")[0].getState().value;
						const discount = parseNumber(model.getElementByTag<FormHiddenExpression>("ruzne-sleva")[0].getState().value);

						const afterDiscount = total - (total * (discount / 100));

						return formatNumber(afterDiscount, 2);
					},
					style: "summary",
					suffix: "Kč"
				})
			])
		]),
	]),
	// finální suma
	SectionGroup({
		spaceBefore: true
	}, [
		Section({},
			[
				Row({}, [
					FieldText({
						id: "montaz-a-doprava-v-cene",
						value: "Montáž a doprava v ceně."
					}),
				]),
				Row({}, [
					FieldText({
						id: "sdk-konstrukce",
						value: "Případná SDK konstrukce ve vizualizaci kuchyně NENÍ součástí cenové nabídky."
					}),
				]),
				Row({}, [
					FieldText({
						id: "standardni material",
						value: "Standardní materiál: vodovodní hadice pro baterii do 0.5m (bez roháčků), sifon, odtahová flexi roura pro digestoř max 1m."
					}),
				]),
				Row({
					colorSchema: "heading",
					display: (model) => {
						const discount1 = parseNumber(model.getElementByTag<FormHiddenExpression>("skrinky-sleva")[0].getState().value, 0);
						const discount2 = parseNumber(model.getElementByTag<FormHiddenExpression>("spotrebice-sleva")[0].getState().value, 0);
						const discount3 = parseNumber(model.getElementByTag<FormHiddenExpression>("ruzne-sleva")[0].getState().value, 0);

						return discount1 === 0 && discount2 === 0 && discount3 === 0;
					}
				}, [
					FieldLabel({
						label: "Celková cena",
						style: "summary"
					}),
					FieldLabel({
						width: "1/6",
						align: "right",
						value: (model) => {
							const total1 = model.getElementByTag<FormHiddenExpression>("skrinky-celkem-po-sleve")[0].getState().value;
							const total2 = model.getElementByTag<FormHiddenExpression>("spotrebice-celkem-po-sleve")[0].getState().value;
							const total3 = model.getElementByTag<FormHiddenExpression>("ruzne-celkem-po-sleve")[0].getState().value;

							const sum = total1 + total2 + total3;

							return formatNumber(sum, 2);
						},
						style: "summary",
						suffix: "Kč"
					})
				]),
				Row({
					colorSchema: "highlight",
					display: (model) => {
						const discount1 = parseNumber(model.getElementByTag<FormHiddenExpression>("skrinky-sleva")[0].getState().value, 0);
						const discount2 = parseNumber(model.getElementByTag<FormHiddenExpression>("spotrebice-sleva")[0].getState().value, 0);
						const discount3 = parseNumber(model.getElementByTag<FormHiddenExpression>("ruzne-sleva")[0].getState().value, 0);

						return discount1 > 0 || discount2 > 0 || discount3 > 0;
					}
				}, [
					FieldLabel({
						label: "Celková cena po slevě vč. DPH",
						style: "summary"
					}),
					FieldLabel({
						width: "1/6",
						align: "right",
						value: (model) => {
							const total1 = model.getElementByTag<FormHiddenExpression>("skrinky-celkem-po-sleve")[0].getState().value;
							const total2 = model.getElementByTag<FormHiddenExpression>("spotrebice-celkem-po-sleve")[0].getState().value;
							const total3 = model.getElementByTag<FormHiddenExpression>("ruzne-celkem-po-sleve")[0].getState().value;

							const sum = total1 + total2 + total3;

							return formatNumber(sum, 2);
						},
						style: "summary",
						suffix: "Kč"
					})
				])
			])
	])
]);